import { productRecommendationModule } from './views/productRecommendation/module';
import { productBoostModule } from './views/productBoost/module';
import { saleRateIndexingRuleModule } from './views/saleRateIndexingRule/module';
import { groupIndexingRuleModule } from './views/groupIndexingRule/module';
import { productIndexingModule } from './views/productIndexing/module';
import { menuInitialRecommendationModule } from './views/menuInitialRecommendation/module';
import { menuBannerRecommendationModule } from './views/menuBannerRecommendation/module';
import { linkTreeModule } from './views/linkTree/module';
import { tableQrModule } from './views/tableQr/module';

export const manualConfigModule = {
  modules: {
    productBoost: productBoostModule,
    saleRateIndexingRule: saleRateIndexingRuleModule,
    groupIndexingRule: groupIndexingRuleModule,
    productIndexing: productIndexingModule,
    productRecommendation: productRecommendationModule,
    menuInitialRecommendation: menuInitialRecommendationModule,
    menuBannerRecommendation: menuBannerRecommendationModule,
    linkTree: linkTreeModule,
    tableQr: tableQrModule,
  },
};
